import React from 'react';
import Toolbar from 'react-big-calendar/lib/Toolbar';

export default class CalendarToolbar extends Toolbar {
  render() {
    return (
      <div className="rbc-toolbar">
        <div className="rbc-btn-group">
          <button type="button" onClick={() => this.navigate('TODAY')}>today</button>
          <button type="button" onClick={() => this.navigate('PREV')}>back</button>
          <button type="button" disabled>{this.props.label}</button>
          <button type="button" onClick={() => this.navigate('NEXT')}>next</button>
        </div>
      </div>
    );
  }
}
